<template>
  <div id="app">
    <!-- <router-view  v-wechat-title="$route.meta.title"/> -->
    <keep-alive >
      <router-view  v-if="$route.meta.keepAlive"> </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"> </router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  created(){
    
  }
}
</script>


<style scoped lang="less" >

</style>



// WEBPACK FOOTER //
// src/App.vue